import _classCallCheck from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Matrix\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Matrix\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Matrix\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Matrix\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Matrix\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { vgField } from '../../channeldef';
import { duplicate, hash as _hash } from '../../util';
import { unique } from './../../util';
import { DataFlowNode } from './dataflow';
/**
 * A class for the join aggregate transform nodes.
 */

export var JoinAggregateTransformNode =
/*#__PURE__*/
function (_DataFlowNode) {
  _inherits(JoinAggregateTransformNode, _DataFlowNode);

  function JoinAggregateTransformNode(parent, transform) {
    var _this;

    _classCallCheck(this, JoinAggregateTransformNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(JoinAggregateTransformNode).call(this, parent));
    _this.transform = transform;
    return _this;
  }

  _createClass(JoinAggregateTransformNode, [{
    key: "clone",
    value: function clone() {
      return new JoinAggregateTransformNode(null, duplicate(this.transform));
    }
  }, {
    key: "addDimensions",
    value: function addDimensions(fields) {
      this.transform.groupby = unique(this.transform.groupby.concat(fields), function (d) {
        return d;
      });
    }
  }, {
    key: "dependentFields",
    value: function dependentFields() {
      var out = new Set();
      this.transform.groupby.forEach(function (f) {
        return out.add(f);
      });
      this.transform.joinaggregate.map(function (w) {
        return w.field;
      }).filter(function (f) {
        return f !== undefined;
      }).forEach(function (f) {
        return out.add(f);
      });
      return out;
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      return new Set(this.transform.joinaggregate.map(this.getDefaultName));
    }
  }, {
    key: "getDefaultName",
    value: function getDefaultName(joinAggregateFieldDef) {
      return joinAggregateFieldDef.as || vgField(joinAggregateFieldDef);
    }
  }, {
    key: "hash",
    value: function hash() {
      return "JoinAggregateTransform ".concat(_hash(this.transform));
    }
  }, {
    key: "assemble",
    value: function assemble() {
      var fields = [];
      var ops = [];
      var as = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.transform.joinaggregate[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var joinaggregate = _step.value;
          ops.push(joinaggregate.op);
          as.push(this.getDefaultName(joinaggregate));
          fields.push(joinaggregate.field === undefined ? null : joinaggregate.field);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var groupby = this.transform.groupby;
      return Object.assign({
        type: 'joinaggregate',
        as: as,
        ops: ops,
        fields: fields
      }, groupby !== undefined ? {
        groupby: groupby
      } : {});
    }
  }]);

  return JoinAggregateTransformNode;
}(DataFlowNode);